import reviseRequest from '@apis/revise'
import {Button, Flex, Text} from '@chakra-ui/react'
import {Input} from 'antd'
import {useState} from 'react'
import {useSelector} from 'react-redux'
import useExamRoom from './useExamRoom'
import rightAudio from '@assets/audios/right.mp3'
import wrongAudio from '@assets/audios/wrong.mp3'

const TypingPhrase = ({
  isLoading,
  setIsLoading,
  setDataReply,
  setIsResult,
  setIsShowReplyBox,
  setDataMessages,
}: {
  isLoading: any
  setIsLoading: any
  setDataReply: any
  setIsResult: any
  setIsShowReplyBox: any
  setDataMessages: any
}) => {
  const {currentQuestion, isDisableReply} = useSelector(
    (state: any) => state.revise,
  )
  const [inputValue, setInputValue] = useState<any>('')
  const {TextArea} = Input
  const {handlePlayAudio, handlePauseAudio} = useExamRoom()

  const handleChangeInputValue = (e: any) => {
    setInputValue(e.target.value)
  }

  const handleSubmitInputValue = async () => {
    if (!inputValue) {
      return
    }
    setIsLoading(true)
    let paragraph = ''
    currentQuestion.data.timeline.forEach((item: any) => {
      paragraph += `${item.character_name}: ${item.transcript} \n `
    })
    const params = {
      question: currentQuestion.data.question.question,
      user_answer: inputValue,
      paragraph,
    }
    const res = (await reviseRequest.checkUserAnswer(params)) as any
    if (res.status === 200) {
      const newMessage = {
        type: 'user',
        msg: inputValue,
      }
      const botMessage = [
        {
          type: 'bot',
          msg: res.data.data?.is_correct
            ? 'Bạn trả lời hoàn toàn chính xác 🥳'
            : 'Không sao cả, mỗi lần sai là một bước tiến tới thành công 🌟',
        },
        {
          type: 'bot',
          msg: 'Bấm TIẾP TỤC để làm bài tiếp theo nha!',
        },
      ]
      if (res.data.data?.is_correct) {
        handlePlayAudio(rightAudio)
      } else {
        handlePlayAudio(wrongAudio)
      }
      setDataReply(inputValue)
      setDataMessages((pre: any) => [...pre, newMessage, ...botMessage])
      setIsResult(res.data.data?.is_correct)
      setIsShowReplyBox(false)
      setIsLoading(false)
    }
  }

  return (
    <Flex w={'90%'} ml={'auto'} mb={'16px'} flexDirection={'column'}>
      <Flex
        gap={'8px'}
        flexDirection={'column'}
        p={'16px'}
        bg={isDisableReply ? '#F5F5F5' : '#E6F7FF'}
        borderRadius={'32px'}>
        {/* <Text
          fontSize={'16px'}
          color={isDisableReply ? 'rgba(0, 0, 0, 0.25)' : '#003A8C'}
          fontWeight={600}>
          {currentQuestion?.data?.question?.answer_template}
        </Text> */}
        <Flex
          p={'16px 16px 32px 16px'}
          bg={'white'}
          borderRadius={'18px'}
          flexDirection={'column'}
          alignItems={'flex-end'}
          sx={{
            '.ant-input-affix-wrapper': {
              border: 'none',
            },
            '.ant-input-outlined.ant-input-affix-wrapper.ant-input-affix-wrapper-focused':
              {
                outline: '2px solid #ffffff !important',
              },
            '.ant-input-disabled': {bg: 'unset'},
            '.ant-input-affix-wrapper-disabled:hover': {bg: 'unset !important'},
          }}>
          <TextArea
            value={inputValue}
            showCount
            disabled={isDisableReply}
            autoSize={true}
            maxLength={200}
            styles={{
              textarea: {
                padding: 0,
              },
            }}
            onChange={handleChangeInputValue}
            placeholder="Trả lời câu hỏi"
          />
        </Flex>
        {!isDisableReply && (
          <Flex justifyContent={'end'}>
            <Button
              isDisabled={!inputValue || isLoading}
              px={'40px'}
              bg={'#1890FF'}
              color={'white'}
              borderRadius={'12px'}
              _hover={{
                bg: '#0069c9',
              }}
              onClick={handleSubmitInputValue}>
              {isLoading ? 'Đang gửi' : 'Gửi'}
            </Button>
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

export default TypingPhrase
